/* eslint-disable @typescript-eslint/no-explicit-any */
import { LoadOptions } from 'devextreme/data';
import CustomStore, { ResolvedData } from 'devextreme/data/custom_store';

export class SearchCriteria {
    searchText?: string;
    skip = 0;
    take = 25;
    sorting?: { column: string; direction: string };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(sortColumn: string, options: LoadOptions<any>, searchText?: string) {
        const sort = { column: sortColumn, direction: 'asc' };

        if (options.sort && options.sort['length'] > 0) {
            sort.column = options.sort[0].selector;
            sort.direction = options.sort[0].desc ? 'desc' : 'asc';
        }

        this.searchText = searchText;
        this.skip = options.skip as number;
        this.take = options.take as number;
        this.sorting = sort;
    }
}

export class BfiCustomStore {
    store: CustomStore | undefined;

    setOnLoad(key: string, onLoad: (criteria: SearchCriteria) => Promise<any>, searchText?: string, hasPaging = true) {
        const processResponse = (response) => {
            const emptyData = {
                data: [],
                totalCount: 0,
                summary: [],
                groupCount: 0,
            };

            if (!response || response.statusCode !== 200) {
                return new Promise((resolve) => {
                    resolve(emptyData);
                });
            }

            const result = response.result;
            const outValue = {
                data: result.data,
                totalCount: result.totalCount,
                summary: result.summary,
                groupCount: result.groupCount,
            };
            return outValue;
        };

        const loadMethod = onLoad;

        this.store = new CustomStore({
            key,
            async load(loadOptions) {
                if (hasPaging && !loadOptions.take) {
                    return processResponse(null) as Promise<ResolvedData<any>>;
                }
                const criteria = new SearchCriteria(key, loadOptions, searchText);
                const response = await loadMethod(criteria);
                return processResponse(response) as Promise<ResolvedData<any>>;
            },
        });
    }
}
